import { t } from '../../i18n/i18n';
import './QuestionChallenge.scss';
import UploadTestFiles from '../UploadTestFiles/UploadTestFiles';
import { AnswerTypeEnum, TestFileType } from '../../constants/enums';
import { useQuestionHandlers } from '../../hooks/useQuestionHandlers';
import { useEffect, useState } from 'react';
import SliderSelector from '../SliderSelector/SliderSelector';
import useCreateScreening from '../../hooks/useCreateScreening';

const QuestionChallenge = ({
  currentTypeQuestion,
  readOnly = false,
  isTranslateABM = false,
  testGroupABM = false,
}) => {
  const {
    handleAddQuestionChallengeAsync,
    currentQuestionData,
    handleAddTestFile,
    handleRemoveTestFile,
    handleUpdateTestFile,
  } = useQuestionHandlers(isTranslateABM);

  const { handleAddTestRubrics, handleInitialSetUpTestChallengeAI } = useCreateScreening();
  const [tab, setTab] = useState(0);

  const [funcionalidad, setFuncionalidad] = useState(80);
  const [legibilidad, setLegibilidad] = useState(10);
  const [mantenibilidad, setMantenibilidad] = useState(10);
  const [eficiencia, setEficiencia] = useState(0);

  const [diagnostic, setDiagnostic] = useState(20);
  const [creativity, setCreativity] = useState(20);
  const [factibility, setFactibility] = useState(20);
  const [structure, setStructure] = useState(20);
  const [impact, setImpact] = useState(20);

  const slidersCode = [
    {
      label: t('LANG_CODE_RUBRIC_1'),
      tooltipLabel: t('LANG_CODE_RUBRIC_1_TOOLTIP'),
      value: funcionalidad,
      setter: setFuncionalidad,
      min: 50,
      initialValue: 80,
      id: 'LANG_CODE_RUBRIC_1',
    },
    {
      label: t('LANG_CODE_RUBRIC_2'),
      tooltipLabel: t('LANG_CODE_RUBRIC_2_TOOLTIP'),
      value: legibilidad,
      setter: setLegibilidad,
      min: 0,
      initialValue: 10,
      id: 'LANG_CODE_RUBRIC_2',
    },
    {
      label: t('LANG_CODE_RUBRIC_3'),
      tooltipLabel: t('LANG_CODE_RUBRIC_3_TOOLTIP'),
      value: mantenibilidad,
      setter: setMantenibilidad,
      min: 0,
      initialValue: 10,
      id: 'LANG_CODE_RUBRIC_3',
    },
    {
      label: t('LANG_CODE_RUBRIC_4'),
      tooltipLabel: t('LANG_CODE_RUBRIC_4_TOOLTIP'),
      value: eficiencia,
      setter: setEficiencia,
      min: 0,
      initialValue: 0,
      id: 'LANG_CODE_RUBRIC_4',
    },
  ];

  const slidersCase = [
    {
      label: t('CASE_RUBRIC_1'),
      tooltipLabel: t('CASE_RUBRIC_1_TOOLTIP'),
      value: diagnostic,
      setter: setDiagnostic,
      min: 0,
      initialValue: 20,
      id: 'CASE_RUBRIC_1',
    },
    {
      label: t('CASE_RUBRIC_2'),
      tooltipLabel: t('CASE_RUBRIC_2_TOOLTIP'),
      value: creativity,
      setter: setCreativity,
      min: 0,
      initialValue: 20,
      id: 'CASE_RUBRIC_2',
    },
    {
      label: t('CASE_RUBRIC_3'),
      tooltipLabel: t('CASE_RUBRIC_3_TOOLTIP'),
      value: factibility,
      setter: setFactibility,
      min: 0,
      initialValue: 20,
      id: 'CASE_RUBRIC_3',
    },
    {
      label: t('CASE_RUBRIC_4'),
      tooltipLabel: t('CASE_RUBRIC_4_TOOLTIP'),
      value: structure,
      setter: setStructure,
      min: 0,
      initialValue: 20,
      id: 'CASE_RUBRIC_4',
    },
    {
      label: t('CASE_RUBRIC_5'),
      tooltipLabel: t('CASE_RUBRIC_5_TOOLTIP'),
      value: impact,
      setter: setImpact,
      min: 0,
      initialValue: 20,
      id: 'CASE_RUBRIC_5',
    },
  ];

  const optionsPromptSubTypes = [
    { id: 1, name: 'Programación', promptSubType: 'TECH_CHALLENGE_ASYNC_CORRECTION' },
    { id: 2, name: 'Marketing', promptSubType: 'MKT_CHALLENGE_ASYNC_CORRECTION' },
    { id: 3, name: 'Business Case', promptSubType: 'BUSINESS_CHALLENGE_ASYNC_CORRECTION' },
  ];

  useEffect(() => {
    if (currentTypeQuestion === AnswerTypeEnum.CHALLENGE_ASYNC_AI) {
      handleInitialSetUpTestChallengeAI(optionsPromptSubTypes[0].promptSubType, slidersCode);
    }
  }, [currentTypeQuestion]);

  return (
    <div data-testid="question-text d-flex flex-column">
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex flex-row pt-3">
          {optionsPromptSubTypes.map((option, index) => (
            <button
              onClick={() => {
                setTab(index);
                if (index === 0) {
                  handleInitialSetUpTestChallengeAI(option?.promptSubType, slidersCode);
                } else {
                  handleInitialSetUpTestChallengeAI(option?.promptSubType, slidersCase);
                }
              }}
              type="button"
              data-testid={`button-tab-${option?.name}`}
              key={option?.id}
              className={`rounded-0 bg-transparent p-2 d-flex justify-content-center align-items-center mx-2 min-width-button
                  ${
                    index === tab
                      ? 'challenge-question-button-filters-selected'
                      : 'challenge-question-button-filters'
                  }`}
            >
              <span className={` ${index === tab ? 'challenge-tab-selected' : 'challenge-tab'}`}>
                {t(option?.name)}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="d-flex flex-row-reverse p-1 my-1">
        <span
          className="text-xxs font-weight-500 text-muted cursor-pointer"
          onClick={() => window.open(process.env.RAZZLE_RUNTIME_CHALLENGE_EXPLANATION, '_blank')}
        >
          {t('CREATE_SCREENING_YOUR_QUESTION_CHALLENGE_EXPLANATION')}
        </span>
      </div>
      <>
        {
          <UploadTestFiles
            fileTypes={[TestFileType.PDF]}
            maxFiles={1}
            handleAddFile={handleAddTestFile}
            handleRemoveFile={handleRemoveTestFile}
            handleUpdateFile={handleUpdateTestFile}
            testFiles={currentQuestionData?.testFiles ?? []}
            id="test"
          />
        }
      </>
      <SliderSelector
        handleLangCodesAIRubrics={handleAddTestRubrics}
        sliders={tab === 0 ? slidersCode : slidersCase}
      />
      <div className="mt-4 mx-2">
        <span className="text-title font-weight-800">
          {t('CREATE_EVALUATION_ADD_CUSTOM_AI_INSTRUCTIONS')}
        </span>

        <textarea
          name="concepts"
          className={`concepts-containers outline-none w-100 mt-1 mx-2 p-2 px-3 text-xs font-weight-400  ${
            currentQuestionData?.concepts?.length ? 'selected-border' : 'unselected-border'
          }`}
          rows="3"
          onChange={(e) => handleAddQuestionChallengeAsync(e)}
          value={currentQuestionData?.concepts ?? ''}
          maxLength={1000}
          data-testid="question-text-concepts-textarea"
          placeholder={t('PLACEHOLDER_ADD_CUSTOM_AI_INSTRUCTIONS')}
        />
      </div>
    </div>
  );
};

export default QuestionChallenge;
